import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StickyCart = ({ cartItems, onCheckout, onToggleCart, isVisible }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(price);
  };

  const getTotalItems = () => {
    return cartItems?.reduce((total, item) => total + item?.quantity, 0);
  };

  const getTotalPrice = () => {
    return cartItems?.reduce((total, item) => total + (item?.price * item?.quantity), 0);
  };

  const totalItems = getTotalItems();
  const totalPrice = getTotalPrice();

  if (!isVisible || totalItems === 0) return null;

  return (
    <>
      {/* Desktop Sticky Cart */}
      <div className="hidden lg:block fixed right-6 top-1/2 transform -translate-y-1/2 z-50">
        <div className="bg-card border border-border rounded-lg shadow-elevation-4 p-4 w-80 max-h-96 overflow-hidden">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">Your Cart</h3>
            <Button
              variant="ghost"
              size="xs"
              iconName="X"
              onClick={onToggleCart}
              className="text-muted-foreground hover:text-foreground"
            />
          </div>
          
          {/* Cart Items */}
          <div className="space-y-3 mb-4 max-h-48 overflow-y-auto">
            {cartItems?.map((item, index) => (
              <div key={`${item?.id}-${item?.type}-${index}`} className="flex items-center justify-between text-sm">
                <div className="flex-1">
                  <p className="font-medium text-foreground truncate">{item?.name}</p>
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <span className="capitalize">{item?.type}</span>
                    {item?.selectedSize && (
                      <>
                        <span>•</span>
                        <span>Size {item?.selectedSize}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-medium text-foreground">
                    {item?.quantity}x {formatPrice(item?.price)}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          {/* Total */}
          <div className="border-t border-border pt-4 mb-4">
            <div className="flex items-center justify-between text-lg font-semibold text-foreground">
              <span>Total ({totalItems} items)</span>
              <span>{formatPrice(totalPrice)}</span>
            </div>
          </div>
          
          {/* Checkout Button */}
          <Button
            variant="default"
            size="lg"
            onClick={onCheckout}
            iconName="ShoppingCart"
            iconPosition="left"
            className="w-full"
          >
            Proceed to Checkout
          </Button>
        </div>
      </div>
      {/* Mobile Floating Cart */}
      <div className="lg:hidden fixed bottom-4 left-4 right-4 z-50">
        <div className="bg-card border border-border rounded-lg shadow-elevation-4 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <Icon name="ShoppingCart" size={20} color="white" />
              </div>
              <div>
                <p className="font-medium text-foreground">
                  {totalItems} item{totalItems > 1 ? 's' : ''} in cart
                </p>
                <p className="text-sm text-muted-foreground">
                  {formatPrice(totalPrice)}
                </p>
              </div>
            </div>
            
            <Button
              variant="default"
              onClick={onCheckout}
              iconName="ArrowRight"
              iconPosition="right"
            >
              Checkout
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StickyCart;